export default {
    START: "Start",
    UNSUCCESS: "Unsuccess",
    SUCCESS: "Success",
};
export var KEY_LOCAL_STORAGE = "maat_token_process";
export var KEY_LOCAL_STORAGE_GEO = "maat_liveness";
export var FLOW_MODE = {
    LIVENESS: "liveness",
    ENROLLMENT: "enrollment",
    AUTH_3D: "auth",
};
export var FLOW_CONFIGURATION_ERROR = {
    MUTUALLY_EXCLUSIVE_MODES: "MUTUALLY_EXCLUSIVE_MODES",
    MISSING_ENROLLMENT_ID: "MISSING_ENROLLMENT_ID",
};
